export enum financialYear {
  AprMar = 'AprMar',
  JanDec = 'JanDec',
  JulJun = 'JulJun',
  OctSep = 'OctSep'
}

export enum area {
  squareFt = 'Sq ft',
  squareMt = 'Sq mt'
}

export enum currency {
  USD = 'USD',
  INR = 'INR',
  JPY = 'JPY'
}

export enum weight {
  kg = 'Kg',
  pound = 'Lbs',
  kan = 'Kan',
  hyo = 'Hyo',
  ton = 'Ton'
}
export enum distance {
  km = 'Km',
  miles = 'Miles',
  ri = 'Ri'
}

export enum electricity {
  kWh = 'kWh'
}

export enum volume {
  litre = 'Ltr',
  Gallon = 'Gallon',
  Sho = 'Sho',
  Kilolitre = 'KL'
}
